import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFire} from "../DumpsterFire";
import {TimelineLite} from "gsap";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";

export class DFWinCapRunner implements SimplePresentation {

    public start(controller: SimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
            delay: 0.5,
            onStart: () => {
                tl.add(DumpsterFire.reelAnticipation.hideContainer(), 0);
            }
        });
        controller.setSkipCallback();
        DumpsterFire.keypadPlugin.setWin(DumpsterFire.model.gameData.accumulatedRoundWin, true);
        DumpsterFire.keypadPlugin.setZeroBetSpinCounter(-1);
        DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.MULTI_FIRE);
        tl.add(DumpsterFire.winCapView.show(() => this.closedCallback(controller)), 0);
    };

    public shouldRun(): boolean {
        return DumpsterFire.model.gameData.brokeTheBank;
    }

    private closedCallback(controller: SimplePresentationRunnerController): void {
        controller.finish();
    }
}